import screeningResultsReducer from "./screeningResultsReducer";

const screeningResultsReducers = {
    screeningResults: screeningResultsReducer
};

export default screeningResultsReducers;